import type { PositionType } from '@infinex/asset-config';
import { getPositionTypeMultiplier } from '@infinex/asset-config';

import type { ChainAssetBalance } from '../balance';

/**
 * Result of summing USD balance values
 */
export type SummedUsdBalances = {
  /** Total USD value of all balances */
  totalUsd: number;
  /** Total 24h change in USD value */
  total24hChange: number;
};

/**
 * Sums USD values for any balance type.
 */
export function sumBalanceUsd(
  balances: readonly ChainAssetBalance[]
): SummedUsdBalances {
  return balances.reduce(
    (acc, balance) => {
      const multiplier = getBalanceMultiplier(balance);

      return {
        totalUsd: acc.totalUsd + (balance.balanceUsd ?? 0) * multiplier,
        total24hChange:
          acc.total24hChange + (balance.balance24hChangeUsd ?? 0) * multiplier,
      };
    },
    { totalUsd: 0, total24hChange: 0 }
  );
}

/**
 * Gets the multiplier for a balance based on its type.
 */
function getBalanceMultiplier(balance: ChainAssetBalance): number {
  if (balance.type === 'position' && balance.positionData) {
    return getPositionTypeMultiplier(
      balance.positionData.positionType as PositionType
    );
  }
  return 1;
}
